import React, { useEffect } from 'react';
import '../assets/css/dic.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSaveBookmarkMutation, useTranslateQuery } from '../Redux/Apis/bookmarkApi';
import { toast } from 'react-toastify';

interface PopupProps {
  content: string;
  onClose: () => void;
}

const Dictionary: React.FC<PopupProps> = ({ content, onClose }) => {
  const {
      data,
      isLoading,
      isSuccess,
  } = useTranslateQuery(content)
  const [saveBookmark] = useSaveBookmarkMutation()

  const save = async () => {
    try {
        const bookmark = await saveBookmark({word:content}).unwrap()
        if (bookmark) toast.success('کلمه به بوکمارک های شما اصافه شد.');
        else toast.error('کلمه مورد نظر از قبل ثبت شده است!');
    } catch (err:any){
        console.log(err);
        // const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
    }
}

  const handleClickOutside = (event: MouseEvent) => {
    const popupContent = document.querySelector('.popup-content');
    if (popupContent && !popupContent.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='dictionary' >
      <div className="popup-container">
        <div className="popup-content">
          <div className='topbar'>
            <h4 className='name'>Dictionary<FontAwesomeIcon icon="spell-check" className='me-2 ms-3'/></h4>
            <span className="close" onClick={onClose}>
              &times;
            </span>
          </div>
          <div className='content mt-5 text-end' dir='ltr'>
            <div className='p-2 border border-primary border-2 d-flex justify-content-between align-items-center'>
              <h6 className='mt-2 me-1'>{content}</h6>
              <button type="button" onClick={save} className="btn btn-outline-primary" data-bs-toggle="button"><FontAwesomeIcon className='ms-2 mt-1' icon="heart"/>save</button>
            </div>
            <hr />
            {isLoading && <p>Translating...</p>}
            {isSuccess && data && <>
              <div className='border p-2'>
                <h5>Persian:</h5>
                {data.fa ? <p className='text-start' dir='rtl'>{data.fa}</p> : <p>Word Not Found!</p>}
              </div>
              <div className='border p-2 mt-2 overflow-scroll' style={{maxHeight:"500px"}}>
                <h5>English:</h5>
                {data.en ? 
                  <>
                  <h6 className='bg-secondary text-white p-1 border border-2'> Definitions:</h6>
                  <div className='px-2'>
                  {data.en.definitions?.map((row: string,index: number) => 
                    <p key={index}>{row}</p>
                  )}
                  </div>
                  {data.en.functionalLabel && 
                    <>
                      <h6 className='bg-secondary text-white p-1 border border-2'> Functional Label:</h6>
                      <p className='p-2'>{data.en.functionalLabel}</p>
                    </>
                  }
                  <h6 className='bg-secondary text-white p-1 border border-2 mt-2'> Stems:</h6>
                  <div className='px-2'>
                  {data.en.stems?.map((row: string,index: number) => 
                    <p className='m-0 p-0' key={index}>{row}</p>
                  )}
                  </div>
                  <h6 className='bg-secondary text-white p-1 border border-2 mt-2'> Pronunciation:</h6>
                  <div className='px-2'>
                  {data.en.pronunciation?.map((row: string,index: number) => 
                    <p className='m-0 p-0' key={index}>{row}</p>
                  )}
                  </div>
                  {data.en.firstKnownUse && 
                    <>
                      <h6 className='bg-secondary text-white p-1 border border-2 mt-2'> First Known Use:</h6>
                      <p className='p-2'>{data.en.firstKnownUse}</p>
                    </>
                  }
                  </>
                  :
                  <p>Word Not Found!</p>
                }
              </div>
            </>}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Dictionary;